export enum BLOG_ACTION_TYPES {
  FETCH_ALL_DATA = "blog/FETCH_ALL_DATA",
  UPDATE_BLOG = "blog/UPDATE_BLOG",
  SET_DATA = "blog/SET_DATA",
  SET_IS_LOADING = "blog/SET_IS_LOADING",
}
